import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { of, Subject } from 'rxjs';
import { switchMap, takeUntil, tap } from 'rxjs/operators';

import { CompaniesService } from '../../state/companies.service';
import { InstrumentsQuery } from '../../state/instruments.query';
import { InstrumentsService } from '../../state/instruments.service';
import { CompaniesQuery } from '../../state/companies.query';
import { MarketDataService } from '../../state/marketdata.service';

@Component({
    selector: 'app-price-list',
    templateUrl: './price-list.component.html',
    styleUrls: ['./price-list.component.scss']
})
export class PriceListComponent implements OnInit, OnDestroy {
    unsubscribe$ = new Subject();
    routes = [
        { path: './valuation', label: 'Valuation' },
        { path: './info', label: 'Company Info' }
    ];
    @ViewChild('actions', { static: true }) actions: TemplateRef<any> | undefined;

    activeCompany$ = this.companiesQuery.activeCompany$;
    constructor(
        public instrumentsQuery: InstrumentsQuery,
        public instrumentsService: InstrumentsService,
        public companiesService: CompaniesService,
        public companiesQuery: CompaniesQuery,
        public marketDataService: MarketDataService
    ) {
        // TODO: companies should be fetched and populated somewhere else...
        this.companiesService.get().pipe(takeUntil(this.unsubscribe$)).subscribe();
    }

    ngOnInit(): void {
        // get all instruments...
        this.instrumentsService
            .get()
            .pipe(
                // ...once fetched, switch to new observable for sub instruments...
                switchMap((_) => this.instrumentsQuery.selectSubInstruments()),
                // ...tap into observable stream and...
                tap((instruments) => {
                    // ...select first instrument or null if no instruments are available
                    this.instrumentsService.setActive(
                        instruments[0]?.instrumentId || null
                    );
                }),
                takeUntil(this.unsubscribe$)
            )
            .subscribe();

        // get market data for active instrument
        this.instrumentsQuery
            .selectActiveId()
            .pipe(
                // ...when selected instrument changes, switch to...
                switchMap((instrumentId) =>
                    // ...market data observable if instrument id is not null...
                    instrumentId !== null && instrumentId !== undefined
                        ? this.marketDataService.get(instrumentId)
                        : of([])
                ),
                takeUntil(this.unsubscribe$)
            )
            .subscribe();
    }

    ngOnDestroy() {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }
}
